import { render, staticRenderFns } from "./breadcrumb-nav.vue?vue&type=template&id=688fe1b8"
import script from "./breadcrumb-nav.vue?vue&type=script&lang=ts"
export * from "./breadcrumb-nav.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports